import axios from "axios";
import config from "../utils/config";

export const getLeadInfoAPI = async (emailId) => {
  const baseURL = config.API_URL;
  const path = "/ops-monitor/get-lead-info";
  const res = await axios.post(baseURL + path, {
    email: emailId,
  });
  return res.data;
};

export const createActivityOnLeadAPI = async (
  leadId,
  activityEventId,
  activityNote,
  activityUTCDateTime,
  customFields,
  appointementData,
  insuranceData
) => {
  const baseURL = config.API_URL;
  const path = "/ops-monitor/create-activity-on-lead";
  const res = await axios.post(baseURL + path, {
    lead_id: leadId,
    activity_event: activityEventId,
    activity_note: activityNote,
    activity_datetime: activityUTCDateTime,
    custom_fields: customFields,
    appointment_data: appointementData,
    insurance_data: insuranceData,
  });
  return res.data;
};

export const getLeadActivityReport = async (email) => {
  const baseURL = config.API_URL;
  const path = `/ops_monitoring/get_lead_activity_report?email=${encodeURIComponent(
    email
  )}`;
  const res = await axios.get(baseURL + path);
  return res.data;
};

export const getLeadFromName = async (name) => {
  const baseURL = config.API_URL;
  const path = `/ops-monitor/get-lead-by-name?name=${name}`;
  const res = await axios.get(baseURL + path);
  return res.data;
};

export const sendSlackMessagePaidDisposition = async (
  name,
  disposition,
  appointementData
) => {
  const baseURL = config.API_URL;
  const path = "/ops-monitor/post-paid-disposition-slack";
  const body = {
    name,
    disposition,
    appointment_data: appointementData,
  };
  const res = await axios.post(baseURL + path, body);
  return res.data;
};
